import React, { useState } from 'react';
import '../styles/Header.css';
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header secondary sticky-top">
      <div className="container-fluid">
        <div className="header-content">
          <div className="header-left">
            <a href="/" className="logo-link">
              <img 
                className="logo" 
                src="https://metroblue.com.ng/assets/website/img/metroblue-logo.jpg" 
                alt="metroblue" 
              />
            </a>
            
            <nav className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
              <ul className="nav-list">
                <li><a href="/">Home</a></li>
                
                <li className="nav-dropdown">
                  <a href="#" className="nav-link">
                    Company <i className="fa fa-angle-down"></i>
                  </a>
                  <div className="sub-menu">
                    <ul>
                      <li><a href="https://metroblue.com.ng/aboutmetroblue">About Us</a></li>
                      <li><a href="https://metroblue.com.ng/contactus">Contact Us</a></li>
                      <li><a href="https://metroblue.com.ng/careers">Careers</a></li>
                    </ul>
                  </div>
                </li>
                
                <li className="nav-dropdown">
                  <a href="#" className="nav-link">
                    Solutions <i className="fa fa-angle-down"></i>
                  </a>
                  <div className="sub-menu">
                    <ul>
                      <li><a href="https://metroblue.com.ng/oursolutions">Metroblits</a></li>
                      <li><a href="https://metroblue.com.ng/oursolutions">Enterprise</a></li>
                      <li><a href="https://metroblue.com.ng/oursolutions">Educesol</a></li>
                    </ul>
                  </div>
                </li>
                
                <li className="nav-dropdown">
                  <a href="#" className="nav-link">
                    Services <i className="fa fa-angle-down"></i>
                  </a>
                  <div className="sub-menu">
                    <ul>
                      <li><a href="https://metroblue.com.ng/ourservices">Software App</a></li>
                      <li><a href="https://metroblue.com.ng/ourservices">Mobile App</a></li>
                      <li><a href="https://metroblue.com.ng/ourservices">Marketing</a></li>
                      <li><a href="https://metroblue.com.ng/ourservices">Website</a></li>
                    </ul>
                  </div>
                </li>
                
                <li><a href="https://metroblue.com.ng/traininginfo">Training</a></li>
              </ul>
            </nav>
          </div>
          
          <div className="header-right">
            <a href="https://metroblue.com.ng/login" className="login-link">
              <i className="fa fa-sign-in-alt icon" aria-hidden="true"></i>
            </a>
            
            <button className="menu-toggle" onClick={toggleMenu}>
              <i className="fa fa-bars"></i>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;